import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {
  @Input() dismissible = true;
  @Input() child = false;
  @Input() classes: string;
  @Input() type: string;
  @Input() value: string;

  @Output() close: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  closeClick( dontClose = false ) {
    
    this.close.emit();
    if( this.value ){   // clear the alert
      this.value='';
    }
    
  }

}
